class EpicurioProductMediaNav extends HTMLElement {
  connectedCallback() {
    this.previousButton = this.querySelector('[data-epf-media-prev]');
    this.nextButton = this.querySelector('[data-epf-media-next]');
    this.mediaArea = this.closest('.product-information__media');
    this.scroller = this.mediaArea?.querySelector('.media-gallery__grid');

    if (!this.scroller || !this.previousButton || !this.nextButton) {
      this.hidden = true;
      return;
    }

    this.handlePrevious = () => this.scrollBySlide(-1);
    this.handleNext = () => this.scrollBySlide(1);
    this.handleScroll = () => this.updateState();
    this.handleResize = () => this.updateState();

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize, { passive: true });

    requestAnimationFrame(() => this.updateState());
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.scroller?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  scrollBySlide(direction) {
    const firstSlide = this.scroller?.querySelector('.product-media-container');
    if (!firstSlide || !this.scroller) return;

    const styles = getComputedStyle(this.scroller);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const distance = firstSlide.getBoundingClientRect().width + gap;

    this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  updateState() {
    if (!this.scroller) return;

    const maxScrollLeft = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
    const tolerance = 3;
    const canScroll = maxScrollLeft > tolerance;

    this.hidden = !canScroll;
    this.previousButton.disabled = !canScroll || this.scroller.scrollLeft <= tolerance;
    this.nextButton.disabled = !canScroll || this.scroller.scrollLeft >= maxScrollLeft - tolerance;
  }
}

if (!customElements.get('epicurio-product-media-nav')) {
  customElements.define('epicurio-product-media-nav', EpicurioProductMediaNav);
}
